import { getAxiosInstance } from "../../../api";

export const bulkUploadAudio = async (endpoint, formData, onUploadProgress) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(endpoint, formData, {
      onUploadProgress,
    });
    return response;
  } catch (error) {
    return error.response?.data ?? { status_code: 500, message: error.message };
  }
};
